import { gql } from 'apollo-boost';

export const LOGIN = gql`mutation($id: ID!, $pwd: String!) {
	login(id: $id, pwd: $pwd)
}`;

export const SIGNUP = gql`mutation($user: UserInput!){
	createUser(user: $user)
}`;

export const MUT_FORGOT_PASSWORD = gql`mutation forgotPassword($emailId: String!) {
	forgotPassword(emailId: $emailId)
}`;
